/* eslint-disable import/prefer-default-export */
/**
 * Converte uma ou mais coordenadas em sistema cartesiano para SVG.
 * @param {[Number, Number]|[Number, Number][]} point Coordenada ou array de coordenadas.
 * @returns {[Number, Number]|[Number, Number][]}.
 */
export function cartesianPointToSvg(point) {
  if (Array.isArray(point[0])) {
    return point.map(cartesianPointToSvg);
  }

  return [point[0], -point[1]];
}
